import { salesAndPurchasesVisibilityColumns } from '@quasar/components/SaleSummaries/visibilityColumns';

import { type DataSetConfig } from '../types';

const initialSalesAndPurchaseConfig: DataSetConfig = {
  sorting: [{ field: 'totalSale', order: 'desc' }],
  columnsVisibility: salesAndPurchasesVisibilityColumns,
};

export { initialSalesAndPurchaseConfig };
